export default __webpack_public_path__ + "5957889949d0d422b5b9088fa8b20936.png";